import { useMemo } from 'react';
import { PermissionSetType } from 'api/models';
import { TranslationKey, useTranslate } from 'hooks/use-translation';

export const PermissionMap = {
  [PermissionSetType.AccountAdmin]: 'account_admin',
  [PermissionSetType.AccountVendorCollaborator]: 'collaborator',
  [PermissionSetType.SuperUser]: 'super_user',
};

export const usePermissionOptions = (): {
  label: string;
  value: number;
}[] => {
  const translate = useTranslate();
  const permissions = useMemo(
    () => [
      {
        label: translate(
          `permissions.${
            PermissionMap[PermissionSetType.AccountAdmin]
          }` as TranslationKey,
        ),
        value: PermissionSetType.AccountAdmin,
        description: translate(
          `permissions.${
            PermissionMap[PermissionSetType.AccountAdmin]
          }.help_text` as TranslationKey,
        ),
      },
      {
        label: translate(
          `permissions.${
            PermissionMap[PermissionSetType.SuperUser]
          }` as TranslationKey,
        ),
        value: PermissionSetType.SuperUser,
        description: translate(
          `permissions.${
            PermissionMap[PermissionSetType.SuperUser]
          }.help_text` as TranslationKey,
        ),
      },
      {
        label: translate(
          `permissions.${
            PermissionMap[PermissionSetType.AccountVendorCollaborator]
          }` as TranslationKey,
        ),
        value: PermissionSetType.AccountVendorCollaborator,
        description: translate(
          `permissions.${
            PermissionMap[PermissionSetType.AccountVendorCollaborator]
          }.help_text` as TranslationKey,
        ),
      },
    ],
    [translate],
  );

  return permissions;
};
